/* eslint-disable no-lonely-if */
/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom'
import { deleteGDCDetaliedPlan, deleteGDCRoadMap, getGDCDetaliedPlan, getGDCRoadMap, postGDCDetaliedPlan, postGDCRoadMap, putGDCDetaliedPlan, putGDCRoadMap } from '@auteco/services/gdcServices';
import { Box, Button, Paper } from '@material-ui/core';
import { CardInfo } from '../CardInfo';
import { CardInfoStatic } from '../CardInfoStatic';
import { useStyles } from './styles';
import { AlertAddDate } from '../AlertAddDate';

const PlansList = ({ partner, companyName, nit, isEnabled }) => {
    const [roadMapList, setRoadMapList] = useState([])
    const [plansList, setPlansList] = useState([])
    const [finishedPlans, setFinishedPlans] = useState([])
    const [alertInfo, setAlertInfo] = useState({})
    const [selectedCards, setSelectedCards] = useState([])

    const classes = useStyles()
    const history = useHistory()

    const sortArray = (info) => info.sort((a, b) => a.prioridad - b.prioridad)

    const getRoadMap = async () => {
        const { hoja_ruta } = await getGDCRoadMap({ partner })
        if (hoja_ruta) {
            const sortedRoadMap = sortArray(hoja_ruta)
            setRoadMapList(sortedRoadMap)
        }
    }

    const postRoadMap = async ({ item }) => {
        const body = {
            punto_guia_id: item.punto_id,
            titulo: item.titulo,
            texto: item.texto,
            valorar: item.valoracion,
            prioridad: item.prioridad,
            solicitante: partner,
            costo: item.costo,
            finalizacion: item.finalizacion,
        }
        const { success } = await postGDCRoadMap({ params: body })
        return success
    }

    const getDetailedPlan = async () => {
        const { planes } = await getGDCDetaliedPlan({ partner })
        if (planes) {
            const activePlans = planes.filter(plan => plan.finalizado === '0')
            const endPlans = planes.filter(plan => plan.finalizado === '1')
            const sortedPlans = sortArray(activePlans)
            const newFinishedPlans = sortArray(endPlans)
            setPlansList(sortedPlans)
            setFinishedPlans(newFinishedPlans)
        }
    }

    const postDetailedPlan = async ({ item }) => {
        const body = {
            titulo: item.titulo,
            texto: item.texto,
            finalizacion: item.finalizacion,
            valoracion: item.valoracion,
            solicitante: partner,
            prioridad: item.prioridad,
            cluster_id: item.cluster_id,
            punto_id: item.punto_id,
            fecha_cierre: '',
            costo: item.costo
        }
        await postGDCDetaliedPlan({ params: body })
    }

    const putDetailedPlan = async ({ item, multiple }) => {
        const body = {
            id: item.id,
            titulo: item.titulo,
            texto: item.texto,
            valoracion: item.valoracion,
            prioridad: item.prioridad,
            finalizacion: item.finalizacion,
            // solicitante: partner,
            valoracion_final: item.valoracion_final || 0,
            finalizado: item.finalizado || 0,
            fecha_cierre: item.fecha_cierre || '',
            costo: item.costo
        }
        const { id } = await putGDCDetaliedPlan({ params: body })
        if (id && !multiple) {
            getDetailedPlan()
        }
    }

    const updatePriority = (info) => info.map((item, i) => ({ ...item, prioridad: i + 1 }))

    const compareCards = async ({ arr1, arr2, type }) => {
        const differentPriorities = arr1.filter(item1 => {
            const item2 = arr2.find(item => item.id === item1.id)
            return item2 && Number(item2.prioridad) !== Number(item1.prioridad)
        });
        if (type === 'roadMapList') {
            await Promise.all(differentPriorities.map(async (item) => {
                const body = {
                    prioridad: item.prioridad,
                    fecha_cierre: item.fecha_cierre,
                    punto_guia_id: item.punto_id,
                    titulo: item.titulo,
                    texto: item.texto,
                    valorar: item.valoracion,
                    costo: item.costo,
                    finalizacion: item.finalizacion,
                    solicitante: item.socio_id,
                    hoja_ruta_id: item.id,
                }
                await putGDCRoadMap({ params: body })
            }));
        } else if (type === 'plansList') {
            await Promise.all(differentPriorities.map(async (item) => {
                await putDetailedPlan({ item, multiple: true })
            }))
        }
        return differentPriorities;
    }

    const handleCloseAlertInfo = () => {
        setAlertInfo({ ...alertInfo, open: false })
    }

    const handleDragStart = (event, item, sourceList, index) => {
        if (isEnabled) {
            event.dataTransfer.setData('text/plain', JSON.stringify({ item, sourceList, index }));
        }
    };

    const handleDragOver = (event) => {
        if (isEnabled) {
            event.preventDefault()
        }
    };

    const handleReorder = (list, sourceIndex, targetIndex, item) => {
        const updatedList = [...list];
        updatedList.splice(sourceIndex, 1);
        updatedList.splice(targetIndex, 0, item);
        return updatedList;
    }

    const handleTransfer = (sourceList, targetList, sourceIndex, targetIndex, item) => {
        sourceList.splice(sourceIndex, 1);
        targetList.splice(targetIndex, 0, item);
    }


    const handleDrop = async (event, targetList, targetIndex) => {
        event.preventDefault();
        const data = JSON.parse(event.dataTransfer.getData('text/plain'));
        const { item: { titulo, texto, finalizacion, prioridad, valoracion, id, cluster_id, punto_id, costo, socio_id }, sourceList } = data;
        const sourceIndex = data.index;

        const updatedroadMapList = [...roadMapList];
        const updatedplansList = [...plansList];

        if (sourceList === targetList) {
            // Reorder elements within the same list
            let updatedList;

            if (sourceList === 'roadMapList') {
                updatedList = handleReorder(updatedroadMapList, sourceIndex, targetIndex, { titulo, texto, finalizacion, prioridad, valoracion, id, cluster_id, punto_id, costo, socio_id });
                const updatedPriority = updatePriority(updatedList)
                setRoadMapList(updatedPriority)
                compareCards({ arr1: updatedPriority, arr2: updatedList, type: 'roadMapList' })
            } else if (sourceList === 'plansList') {
                updatedList = handleReorder(updatedplansList, sourceIndex, targetIndex, { titulo, texto, finalizacion, prioridad, valoracion, id, cluster_id, punto_id, costo, socio_id });
                const updatedPriority = updatePriority(updatedList)
                setPlansList(updatedPriority)
                compareCards({ arr1: updatedPriority, arr2: updatedList, type: 'plansList' })
            }
        } else {
            // Transfer element between lists
            if (sourceList === 'roadMapList') {
                handleTransfer(updatedroadMapList, updatedplansList, sourceIndex, targetIndex, { titulo, texto, finalizacion, prioridad, valoracion, id, cluster_id, punto_id, costo, socio_id })
                const newRoadMap = updatePriority(updatedroadMapList)
                const newPlansList = updatePriority(updatedplansList)
                const item = newPlansList.find(card => card.id === id)
                await deleteGDCRoadMap({ id })
                await postDetailedPlan({ item })
                await compareCards({ arr1: newRoadMap, arr2: updatedroadMapList, type: 'roadMapList' })
                await getRoadMap()
                await compareCards({ arr1: newPlansList, arr2: updatedplansList, type: 'plansList' })
                await getDetailedPlan()
            } else if (sourceList === 'plansList') {
                handleTransfer(updatedplansList, updatedroadMapList, sourceIndex, targetIndex, { titulo, texto, finalizacion, prioridad, valoracion, id, cluster_id, punto_id, costo, socio_id })
                const newRoadMap = updatePriority(updatedroadMapList)
                const item = newRoadMap.find(card => card.id === id)
                const newPlansList = updatePriority(updatedplansList)
                setRoadMapList(newRoadMap)
                setPlansList(newPlansList)
                await deleteGDCDetaliedPlan({ id })
                await postRoadMap({ item })
                await compareCards({ arr1: newRoadMap, arr2: updatedroadMapList, type: 'roadMapList' })
                await compareCards({ arr1: newPlansList, arr2: updatedplansList, type: 'plansList' })
                await getRoadMap()
            }
        }
    }

    const handleAddCardPDF = ({ event, card }) => {
        if (event.target.checked) {
            setSelectedCards([...selectedCards, card])
        } else {
            setSelectedCards(selectedCards.filter(selected => selected.id !== card.id));
        }
    }

    const handleGeneratePDF = () => {
        const params = {
            selectedCards,
            companyName,
            nit
        }
        history.push('/gdv_home/generar_pdf', params)
    }
    useEffect(() => {
        getRoadMap()
        getDetailedPlan()
    }, [])
    return (
        <>
            <AlertAddDate open={alertInfo.open} onClose={handleCloseAlertInfo} item={alertInfo.item} solicitante={alertInfo.solicitante} getDetailedPlan={getDetailedPlan} updatePriorities={alertInfo.updatePriorities} />
            {selectedCards?.length > 0 &&
                <Button
                    variant='contained'
                    color='primary'
                    className={classes.pdfButton}
                    onClick={handleGeneratePDF}
                >
                    Generar PDF
                </Button>
            }
            <Box className={classes.container}>
                <Box className={classes.listContainer}>
                    <div>
                        <Paper
                            id="element-1"
                            draggable="true"
                            className={classes.title}
                            onDragStart={(event) => handleDragStart(event, 'Hoja de ruta', 'roadMapList', 0)}
                        >
                            Hoja de ruta
                        </Paper>
                    </div>
                    <div className={classes.cardsContainer}>
                        {roadMapList.map((item, index) => (
                            <CardInfo
                                key={item.id}
                                index={index}
                                item={item}
                                type='roadMapList'
                                isEnabled={isEnabled}
                                onDragStart={handleDragStart}
                                onDragOver={handleDragOver}
                                onDrop={handleDrop}
                            />
                        ))}
                        <Paper
                            className={`${classes.emptyCard} ${roadMapList.length > 0 ? classes.emptyCardSm : classes.emptyCardLg}`}
                            draggable="true"
                            onDragStart={(event) => handleDragStart(event, 'Hoja de ruta', 'roadMapList', -1)}
                            onDragOver={handleDragOver}
                            onDrop={(event) => handleDrop(event, 'roadMapList', -1)}
                        />
                    </div>
                </Box>
                <Box className={classes.listContainer}>
                    <div>
                        <Paper
                            id="element-2"
                            draggable="true"
                            className={classes.title}
                            onDragStart={(event) => handleDragStart(event, 'Plan detallado', 'plansList', 0)}
                        >
                            Plan detallado
                        </Paper>
                    </div>
                    <div className={classes.cardsContainer}>
                        {plansList.map((item, index) => (
                            <CardInfo
                                key={item.id}
                                index={index}
                                item={item}
                                type='plansList'
                                isEnabled={isEnabled}
                                onDragStart={handleDragStart}
                                onDragOver={handleDragOver}
                                onDrop={handleDrop}
                                putDetailedPlan={putDetailedPlan}
                                handleAddCardPDF={handleAddCardPDF}
                            />
                        ))}
                        <Paper
                            className={`${classes.emptyCard} ${plansList.length > 0 ? classes.emptyCardSm : classes.emptyCardLg}`}
                            onDragStart={(event) => handleDragStart(event, 'Plan detallado', 'plansList', -1)}
                            onDragOver={handleDragOver}
                            onDrop={(event) => handleDrop(event, 'plansList', -1)}
                        />
                    </div>
                </Box>
                <Box className={`${classes.listContainer} ${classes.listContainerLast}`}>
                    <div>
                        <Paper
                            id="element-2"
                            draggable="true"
                            className={classes.title}
                            onDragStart={(event) => handleDragStart(event, 'Plan detallado', 'plansList', 0)}
                        >
                            Finalizado
                        </Paper>
                    </div>
                    <div className={classes.cardsContainer}>
                        {finishedPlans.map((item) => (
                            <CardInfoStatic item={item} />
                        ))}
                    </div>
                </Box>
            </Box >
        </>
    );
};

export { PlansList };
